/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { AppUtilityService } from '../../core/services/app-utility.service';
import { BehaviorSubject ,  Observable } from 'rxjs';
import { ConfigService } from '../../core/services/config.service';
import { DataStoreService } from '../../core/services/datastore.service';
import { HistoryOps } from '../../core/model/history-ops.model';
import { HttpStatus } from '../../core/model/http-status-enum.model';
import { Injectable } from '@angular/core';
import { LmsLoaderService } from '../../core/services/lms-loader.service';
import { LmsLoggerService } from '../../core/services/lms-logger.service';
import { LocoHistory } from '../../core/model/loco-history.model';
import { MessageDetails } from '../../core/model/message-details.model';
import { MessageHandlerService } from '../../core/services/message-handler.service';
import { PopupService } from '../../core/services/popup.service';
import { Router } from '@angular/router';
import { Tab } from '../../core/model/tab.model';
import { TabData } from '../../core/model/tab-data.model';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';

@Injectable()
export class LocoHistoryService {

  loadData: Observable<LocoHistory>;
  private loadDataBS: BehaviorSubject<LocoHistory>;
  private RESOURCE_URL = '/locomotives';
  private configData: any;
  private apiUrl: string;

  constructor(private http: HttpClient,
    private configService: ConfigService,
    private dataStoreService: DataStoreService,
    private lmsLoggerService: LmsLoggerService,
    private router: Router,
    private lmsLoaderService: LmsLoaderService,
    private messageHandlerService: MessageHandlerService,
    private popupService: PopupService,
    private appUtilityService: AppUtilityService) {
    this.loadDataBS = <BehaviorSubject<LocoHistory>>new BehaviorSubject({});
    this.loadData = this.loadDataBS.asObservable();
    this.configData = this.configService.getConfigData();
    this.apiUrl = this.configData.urls.API_URL;
  }

  resetDefaultPageMode() {
    this.popupService.setPageMode('');
    this.popupService.setSubmitBtnId('');
  }

  load(tab: Tab, historyOps: HistoryOps, fromOtherOperation?: boolean, messageText?: string) {
    this.resetDefaultPageMode();
    let locoHistory: LocoHistory;
    let foundInDataStore = false;
    historyOps = this.checkForHistoryOpsValidity(historyOps);
    if (tab && tab.tabSearchParameter) {
      if (tab.tabSearchParameter.searchText) {
        tab.tabSearchParameter.searchText = tab.tabSearchParameter.searchText.trim();
      } else {
        this.lmsLoaderService.hideLoader();
        return;
      }
      if ('error' === tab.subTypeDetail[tab.subType.toLowerCase()].status) {
        this.lmsLoaderService.hideLoader();
        return;
      }
      if (!this.appUtilityService.isValidLocomotiveId(tab.tabSearchParameter.searchText)) {
        const llocoHistory = <LocoHistory>({
          httpStatus: 400,
          errorMessage: this.configService.getConfigData().messages.invalidLocomotive
        });
        this.loadDataBS.next(llocoHistory);
        this.lmsLoaderService.hideLoader();
        this.lmsLoggerService.logError('LocoHistoryService => load()',
          this.configService.getConfigData().messages.invalidLocomotive);
      } else {
        if (tab.subTypeDetail[tab.subType.toLowerCase()].status !== 'refresh') {
          const tabData = this.dataStoreService.getValue(tab);
          if (tabData) {
            locoHistory = <LocoHistory>(tabData.data[tab.subType]);
            foundInDataStore = true;
            this.loadDataBS.next(locoHistory);
            this.lmsLoaderService.hideLoader();
          }
        } else {
          foundInDataStore = false;
        }

        if (!foundInDataStore) {
          this.lmsLoaderService.showLoader();
          const opr = 'INQL';
          const locoId = this.appUtilityService.formatLocomotiveId(tab.tabSearchParameter.searchText);
          this.lmsLoggerService.logInfo('LocoHistoryService=>load service call starts');
          this.http.get(
            `${this.configService.getConfigData().urls.API_URL}${this.RESOURCE_URL}?id=${locoId}&opr=${opr}&d=${historyOps.days}&dt=${historyOps.displayType}`).pipe(
              tap(() => this.lmsLoggerService.logInfo('LocoHistoryService=>load service call ends'))
            )
            .subscribe((data: any) => {
              if (data && data.priorityCode) {
                const pCode = parseInt(data.priorityCode, 10);
                if (pCode >= 1 && pCode <= 4) {


                  const lLocoHistory = <LocoHistory>{
                    history: data.history,
                    thpHistory: data.thpHistory
                  };
                  const tabData = <TabData>({
                    id: tab.id,
                    subType: tab.subType
                  });

                  tabData.data = tabData.data ? tabData.data : {};
                  tabData.data[tab.subType] = lLocoHistory;

                  lLocoHistory.lastRefreshTime = data.refreshTime;
                  lLocoHistory.refreshTime = data.refreshTime;
                  lLocoHistory.httpStatus = HttpStatus.OK;
                  lLocoHistory.tabId = tab.id;
                  tab.subTypeDetail.history.message = '';
                  tab.tabSearchParameter.searchText = this.appUtilityService.UIformatLocomotiveId(tab.tabSearchParameter.searchText);
                  lLocoHistory.errorMessage = '';
                  this.lmsLoaderService.hideLoader();
                  this.dataStoreService.putValue(tab, tabData);
                  this.loadDataBS.next(lLocoHistory);
                  this.lmsLoggerService.logInfo('LocoHistoryService => load()',
                    `Loco History Fetch Successfull for ${JSON.stringify(tab)}`);
                  if (fromOtherOperation) {
                    this.messageHandlerService.handleMessage(<MessageDetails>({
                      type: this.configData.message.type.client,
                      level: this.configData.message.level.success,
                      target: this.configData.message.target.page,
                      message: messageText
                    }));
                  }
                } else {
                  this.lmsLoaderService.hideLoader();
                  const lLocoHistory = <LocoHistory>({
                    httpStatus: 400,
                    errorMessage: fromOtherOperation ? messageText + ', but ' + data.messageText : data.messageText
                  });
                  this.loadDataBS.next(lLocoHistory);
                  this.lmsLoggerService.logError('LocoHistoryService => load()',
                    data.messageText);
                }
              }
            },
            error => {
              this.lmsLoaderService.hideLoader();
              const lLocoHistory = <LocoHistory>({
                httpStatus: error.status,
                errorMessage: fromOtherOperation ? messageText + ', but an error has occurred while refreshing the page.' : this.appUtilityService.getHttpErroMessage(error, false)
              });
              this.loadDataBS.next(lLocoHistory);
              this.lmsLoggerService.logError('LocoHistoryService => load()',
                this.appUtilityService.getHttpErroMessage(error, false));
            });
        }
      }
    } else {
      this.lmsLoaderService.hideLoader();
      this.loadDataBS.next(null);
    }
  }

  private checkForHistoryOpsValidity(historyOps: HistoryOps) {
    if (historyOps) {
      if (!historyOps.days) {
        historyOps.days = 2;
      }
      if (!historyOps.displayType) {
        historyOps.displayType = ' ';
      }
    } else {
      historyOps = {
        days: 5,
        displayType: ' '
      };
    }
    return historyOps;
  }

  cleanBehaviourSubject() {
    this.loadDataBS.next(null);
  }


}
